// Configuration for optional authentication
export interface AuthConfig {
  enableFrontendAuth: boolean;
  enableRouteGuards: boolean;
  enableSessionTimeout: boolean;
}

export const authConfig: AuthConfig = {
  enableFrontendAuth: false, // Set to true if you want frontend auth checks
  enableRouteGuards: false,  // Set to true if you want route guards
  enableSessionTimeout: false // Set to true if you want frontend session timeout
};
